// Module
var code = `<div class="alert">
  This action will generate both the End of Month (EOM) and T-1 COCREE snapshots for the selected reporting period.
  <br />
  To ensure accurate data capture, please make sure the CBS status is in “Pending Start of Day” immediately after the
  End of Month process of the desired Reporting Period. <br />
  This is the optimal state for snapshot generation. While the action can still be executed outside this status, it will
  pull data based on the current state of the system, which may lead to month end data inconsistencies. <br /><br />
  Example: <br />
  If the system date across all branches is October 1, 2025, and you select September 2025 as the reporting period, the system will generate snapshots using the End of Day (EOD) data from September 30, 2025.
</div>

<div class="alert alert--danger">
  This action may take some time to complete, depending on the volume of the bank’s data.
  <br>It may also temporarily affect the performance of the environment while processing is underway.
  <br>Kindly avoid any other batch actions to avoid performance issues.
</div>


<h2 class="section-header">Please confirm the following:</h2>
<form name="form">
  <table class="table">
    <tbody>
      <tr>
        <td>Branch:</td>
        <td>
          <multiselect
            items="\$ctrl.branches" 
            ng-model="\$ctrl.selectedBranches"
            label-property="'label'"
            class="filter-value {{ 'filter-label-' + filter.label }}"
            ng-model-options="{ allowInvalid: true }"
            select-all-option="true">
          </multiselect>
        </td>
      </tr>
      <tr>
        <td>Submission Type:</td>
        <td>
          <select ng-model="\$ctrl.submissionType"
            ng-options="submissionType.type as submissionType.label for submissionType in \$ctrl.submissionTypes"
            ng-required="true">
          </select>
        </td>
      </tr>
      <tr>
        <td>Report date:</td>
        <td>
          <date output-format="date" ng-model="\$ctrl.reportDate"></date>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="pull-right">
    <button type="submit" class=" btn btn-success" ng-disabled="form.\$invalid" ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/generate-cocree-snapshot/generate-cocree-snapshot.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;